import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Icon } from "@circleco/compass/components/Icon";

import { isImage, isText } from "./attachmentHelpers";
import type { AttachmentItem } from "./types";
import { useTextContent } from "./useTextContent";

interface AttachmentPreviewProps {
  attachment: AttachmentItem;
  className?: string;
}

export const AttachmentPreview = ({
  attachment,
  className,
}: AttachmentPreviewProps) => {
  const { contentType, filename, previewUrl } = attachment;
  const textContent = useTextContent(previewUrl, isText(contentType));

  const baseClass = "size-full overflow-hidden text-inverse select-none";

  if (isImage(contentType) && previewUrl) {
    return (
      <img
        src={previewUrl}
        alt={filename}
        loading="lazy"
        draggable={false}
        className={classNames(baseClass, "object-cover", className)}
      />
    );
  }

  if (isText(contentType) && textContent) {
    return (
      <div
        className={classNames(
          baseClass,
          "whitespace-pre-wrap break-all p-2 text-[6px] leading-tight",
          className,
        )}
      >
        {textContent}
      </div>
    );
  }

  return (
    <div
      className={classNames(
        baseClass,
        "flex items-center justify-center",
        className,
      )}
    >
      <Icon name="file" size="lg" />
    </div>
  );
};
